import React from 'react'
import { Button } from 'antd'
import { useAuth } from '../../authContext'

const NoAccessPage = () => {
  const { user, roles, requiredRole, logout } = useAuth()

  return (
    <div className="stdContent">
      <h1>No access</h1>
      <p>
        {user && user.name ? `${user.name} (${user.upn})` : 'Your account'} is signed in but
        does not have the role required to use this app.
      </p>
      <p>Required role: <strong>{requiredRole}</strong></p>
      <p>Roles on your account: <strong>{roles.length ? roles.join(', ') : 'none'}</strong></p>
      <p>Contact IT/Compliance to have the correct role assigned in Nordlys.</p>
      <Button onClick={logout}>Log out</Button>
    </div>
  )
}

export default NoAccessPage
